import React from 'react'
import PropTypes from 'prop-types'
import Favorite from '@mui/icons-material/Favorite'

const FavoriteIcon = ({ height, width, ...more }) => {
	
	return (
		<Favorite
			height={height}
			width={width}
			{...more}
		/>
	)
}

FavoriteIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default FavoriteIcon
